export default __webpack_public_path__ + "static/media/yellowWarning.2755dd98.svg";